import React from "react";

export const IconLock = ({ className }) => (
    <svg
        x="0px"
        y="0px"
        viewBox="0 0 48 48"
        enableBackground="new 0 0 48 48"
        className={className}
    >
        <path
            fill="currentColor"
            d="M36.7,20h-0.3v-7.6C36.4,5.6,30.9,0,24,0c-3.4,0-6.5,1.4-8.8,3.6C13,5.9,11.6,9,11.6,12.4V20h-0.3  c-2.3,0-4.2,1.9-4.2,4.2v19.7c0,2.3,1.9,4.2,4.2,4.2h25.4c2.3,0,4.2-1.9,4.2-4.2V24.2C40.9,21.9,39,20,36.7,20z M27.6,40.4h-7.2  l1.2-6.3c-1-0.7-1.7-1.9-1.7-3.3c0-2.2,1.8-4.1,4.1-4.1c2.2,0,4.1,1.8,4.1,4.1c0,1.4-0.7,2.6-1.7,3.3L27.6,40.4z M32.2,20H15.8v-7.6  c0-4.5,3.7-8.2,8.2-8.2c4.5,0,8.2,3.7,8.2,8.2V20z"
        />
    </svg>
);

export const IconHome = ({ className, size }) => (
    <svg
        width={size}
        height={size}
        className={className}
        viewBox="0 0 904.41 920"
        fill="currentColor"
    >
        <path d="M858.76,0H376.45c-25.17,0-45.65,21.18-45.65,47.21V216.64h41.39v-65.08h490.83V763.78H372.19v-40.56h-41.39v149.58c0,26.03,20.48,47.2,45.65,47.2h482.31c25.17,0,45.65-21.17,45.65-47.2V47.21c0-26.03-20.48-47.21-45.65-47.21Zm4.26,872.8c0,3.43-2.25,5.81-4.26,5.81H376.45c-2.01,0-4.26-2.38-4.26-5.81v-67.63h490.83v67.63Zm0-762.63H372.19V47.21c0-3.44,2.25-5.82,4.26-5.82h482.31c2.01,0,4.26,2.38,4.26,5.82v62.96Z" />
        <path d="M60.04,756.88c-59.18-2.46-84.14-82.74-30.52-113.6l121.39-69.89,20.65,35.87-121.39,69.89c-4.92,2.84-8.32,7.44-9.55,12.93-2.49,11.1,5.47,22.6,16.75,24.13,5.54,.73,11.08-.82,15.46-4.45l107.85-89.39,26.41,31.88s-107.8,89.36-107.85,89.39c-11.85,9.83-25.67,13.8-39.2,13.23Z" />
        <path d="M381.53,695.32h0c-72.09,0-139.29-35.56-179.75-95.12-32.58-47.96-44.54-105.75-33.66-162.7,10.88-56.96,43.29-106.28,91.25-138.85,36.14-24.55,78.26-37.52,121.8-37.52,72.1,0,139.29,35.56,179.76,95.12,67.26,99,41.42,234.28-57.59,301.56-36.14,24.55-78.27,37.52-121.8,37.52Zm-.36-392.81c-35.21,0-69.29,10.5-98.54,30.38-38.82,26.37-65.05,66.27-73.85,112.37-8.8,46.1,.88,92.87,27.24,131.69,32.75,48.21,87.15,76.99,145.52,76.99,35.21,0,69.29-10.5,98.55-30.38,80.13-54.43,101.04-163.91,46.61-244.05-32.75-48.21-87.16-76.99-145.52-76.99Z" />
        <path d="M484.06,579.92l-23.25-34.22c33.64-22.86,42.42-68.83,19.56-102.48l34.24-23.25c35.68,52.52,21.98,124.28-30.54,159.95Z" />
    </svg>
);

export const IconGiftCard = ({ className, size }) => (
    <svg
        width={size}
        height={size}
        className={className}
        viewBox="0 0 100 100"
        style={{ enableBackground: "new 0 0 100 100" }}
        fill="currentColor"
    >
        <path d="M93.2,9.1H7.9c-1,0-1.8,0.8-1.8,1.8v59.2c0,1,0.8,1.8,1.8,1.8h24.8C30,79,30.3,87.7,30.3,88.2c0,0.7,0.5,1.3,1.1,1.6   c0.7,0.3,1.4,0.1,1.9-0.4l4.4-4.5l3.8,6.1c0.3,0.5,0.9,0.8,1.5,0.8c0.2,0,0.4,0,0.5-0.1c0.8-0.3,1.3-1,1.2-1.8   c-0.3-3.6-0.4-11.6,0.9-18.1h9.6c1.3,6.4,1.2,14.5,0.9,18.1c-0.1,0.8,0.4,1.6,1.2,1.8c0.2,0.1,0.4,0.1,0.5,0.1   c0.6,0,1.2-0.3,1.5-0.8l3.8-6.1l4.4,4.5c0.5,0.5,1.2,0.7,1.9,0.4c0.7-0.3,1.1-0.9,1.1-1.6c0-0.5,0.3-9.2-2.4-16.3h24.8   c1,0,1.8-0.8,1.8-1.8V10.9C95,9.9,94.2,9.1,93.2,9.1z M24.3,59v-6.5c0-2.5,1.1-4.8,2.9-6.1c5.8-4.2,15,3.1,16.7,4.5v1.8   c-2.1-1-4.6-1.4-5.6-1.6c-1-0.2-1.9,0.5-2,1.5c-0.2,1,0.5,1.9,1.5,2c2.7,0.4,5.7,1.5,6.1,2.2c0,0,0.1,0.1,0.1,0.1v2.1   c-3.3-0.9-12.7-2.8-17.7,0.5c-0.6,0.4-1.2,0.9-1.7,1.5C24.4,60.3,24.3,59.6,24.3,59z M58.7,62.2c3.9-0.9,11-2,14.3,0.2   c1,0.6,1.5,1.5,1.7,2.6c-0.5,1.3-3.2,2-5.7,2C65.6,66.9,62.1,65.3,58.7,62.2z M76.8,59c0,0.6-0.1,1.3-0.2,1.9   c-0.5-0.6-1-1.1-1.7-1.5C69.8,56,60.3,58.1,57,58.9v-2c0.1-0.1,0.1-0.2,0.2-0.3c0.4-0.7,3.4-1.8,6.1-2.2c1-0.2,1.6-1.1,1.5-2   c-0.2-1-1.1-1.6-2-1.5c-1,0.2-3.6,0.7-5.7,1.6V51c1.3-1.1,10.9-8.9,16.8-4.6c1.8,1.3,2.9,3.6,2.9,6.1V59z M53.4,61.8h-5.7V49.9h5.7   V61.8z M32.1,67c-2.4,0-5.2-0.6-5.7-2c0.2-1.2,0.7-2,1.7-2.6c3.3-2.2,10.4-1.1,14.3-0.2C39,65.3,35.6,66.9,32.1,67z M41.1,83.6   l-1.6-2.5c-0.3-0.5-0.8-0.8-1.3-0.8c-0.5-0.1-1.1,0.1-1.5,0.5l-2.9,2.9c0.3-4.3,1.2-10.7,4.2-14.5c2-0.8,4-2.1,6-3.8   C41.7,70.6,41.2,78.2,41.1,83.6z M46.7,68.3c0.4-1.1,0.8-2.1,1.3-2.9h5c0.5,0.8,1,1.8,1.3,2.9H46.7z M64.3,80.8   c-0.4-0.4-0.9-0.6-1.5-0.5c-0.5,0.1-1,0.4-1.3,0.8L60,83.6c-0.1-5.4-0.6-13-3-18.2c2,1.7,3.9,2.9,6,3.8c3,3.8,3.9,10.2,4.2,14.5   L64.3,80.8z M91.5,68.3h-15c0.6-0.5,1-1.1,1.4-1.8c1.5-2,2.5-4.8,2.5-7.5v-6.5c0-3.6-1.6-7-4.4-9c-6.7-4.9-15.5,0.4-19.4,3.3   c-0.3-0.4-0.8-0.6-1.4-0.6h-9.4c-0.5,0-1,0.2-1.3,0.6c-4-2.9-12.7-8.1-19.3-3.3c-2.7,2-4.4,5.4-4.4,9V59c0,2.7,0.9,5.5,2.5,7.5   c0.3,0.7,0.8,1.3,1.4,1.8h-15V12.7h81.8V68.3z" />
        <rect x="17" y="19" width="64.7" height="3.5" />
        <rect x="17" y="26" width="64.7" height="3.5" />
        <rect x="17" y="32.7" width="34.3" height="3.5" />
    </svg>
);

export const IconMedal = ({ className, size }) => (
    <svg
        className={className}
        width={size}
        height={size}
        x="0px"
        y="0px"
        fill="currentColor"
        viewBox="2 1 21 21"
        enableBackground="new 2 1 21 21"
    >
        <path d="M19.154,7.273c0.066-0.205-0.007-0.43-0.181-0.557l-1.71-1.25l-0.662-2.012c-0.067-0.204-0.258-0.343-0.473-0.344    l-2.118-0.008l-1.719-1.237c-0.174-0.127-0.41-0.127-0.584,0L9.989,3.104L7.871,3.112c-0.215,0.001-0.406,0.14-0.473,0.344    L6.736,5.468l-1.709,1.25C4.853,6.845,4.78,7.069,4.846,7.274l0.649,2.017l-0.649,2.018c-0.066,0.205,0.007,0.43,0.181,0.557    l1.71,1.25l0.593,1.804l-2.261,3.835c-0.103,0.174-0.09,0.394,0.031,0.555c0.121,0.161,0.327,0.232,0.524,0.184l2.482-0.641    l0.642,2.482c0.057,0.221,0.256,0.375,0.484,0.375c0.26,0,0.274,0,2.75-3.878l2.141,3.632c0.091,0.154,0.255,0.246,0.431,0.246    c0.023,0,0.046-0.002,0.07-0.005c0.2-0.028,0.364-0.174,0.414-0.37l0.642-2.482l2.482,0.641c0.195,0.049,0.403-0.022,0.524-0.184    c0.122-0.161,0.134-0.381,0.031-0.555l-2.128-3.61c0.003-0.007,0.01-0.011,0.013-0.018l0.662-2.012l1.709-1.25    c0.174-0.127,0.247-0.352,0.181-0.557l-0.649-2.017L19.154,7.273z M9.43,19.972L8.95,18.117c-0.069-0.268-0.343-0.427-0.609-0.359    l-1.798,0.464l1.622-2.75l1.824,0.007l1.582,1.139C11.532,16.679,10.232,18.715,9.43,19.972z M15.446,17.758    c-0.266-0.068-0.541,0.092-0.609,0.359l-0.465,1.798l-1.941-3.294c-0.001-0.001-0.002-0.002-0.003-0.003l1.583-1.14l1.612-0.007    l1.621,2.75L15.446,17.758z M18.092,11.271l-1.548,1.132c-0.084,0.062-0.147,0.147-0.18,0.247l-0.589,1.792l-0.052,0.03    l-1.876,0.008c-0.104,0-0.206,0.033-0.29,0.095L12,15.694l-1.557-1.12c-0.084-0.062-0.186-0.095-0.29-0.095l-1.917-0.008    L7.637,12.65c-0.033-0.1-0.096-0.186-0.18-0.247l-1.548-1.132l0.588-1.827c0.032-0.1,0.032-0.207,0-0.307L5.908,7.312L7.456,6.18    c0.084-0.062,0.147-0.147,0.18-0.247L8.235,4.11l1.918-0.008c0.104,0,0.206-0.033,0.29-0.095L12,2.888l1.557,1.12    c0.084,0.062,0.186,0.095,0.29,0.095l1.917,0.008l0.599,1.821c0.033,0.1,0.096,0.186,0.18,0.247l1.548,1.132l-0.588,1.827    c-0.032,0.1-0.032,0.207,0,0.307L18.092,11.271z" />
        <path d="M12,5.541c-2.068,0-3.75,1.683-3.75,3.75s1.682,3.75,3.75,3.75s3.75-1.683,3.75-3.75S14.068,5.541,12,5.541z M12,12.041    c-1.517,0-2.75-1.233-2.75-2.75s1.233-2.75,2.75-2.75s2.75,1.233,2.75,2.75S13.517,12.041,12,12.041z" />
    </svg>
);

export const IconClock = ({ className, size }) => (
    <svg
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
        className={className}
        width={size}
        height={size}
    >
        <g transform="translate(0,-952.36218)">
            <path
                style={{ color: "#ffffff", enableBackground: "accumulate" }}
                d="m 50,967.36216 c -19.32987,0 -35,15.67012 -35,35.00004 0,19.3298 15.67014,35 35,35 19.32986,0 35,-15.6702 35,-35 0,-19.32992 -15.67014,-35.00004 -35,-35.00004 z m 0,9 c 1.1046,0 2,0.8954 2,2 l 0,23.18754 14.96875,14.9687 c 0.78108,0.7811 0.78106,2.0315 0,2.8125 -0.78107,0.7811 -2.03143,0.7811 -2.8125,0 L 48.875,1004.0184 c -0.47487,-0.4551 -0.8285,-0.8392 -0.875,-1.6562 l 0,-24.00004 c 0,-1.1046 0.8954,-2 2,-2 z"
                fill="#ffffff"
                stroke="none"
                marker="none"
                visibility="visible"
                display="inline"
                overflow="visible"
            />
        </g>
    </svg>
);

export const IconSettingsFull = ({ className, size }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        x="0px"
        y="0px"
        width={size}
        height={size}
    >
        <path
            fill="currentColor"
            d="M20.14,12.89a.76.76,0,0,1-.28-.62q0-.27,0-.54a.76.76,0,0,1,.28-.62l1.3-1.06a1.54,1.54,0,0,0,.48-1.66,11.4,11.4,0,0,0-2-3.59,1.38,1.38,0,0,0-1.6-.39l-1.53.64A.69.69,0,0,1,16.16,5l-.44-.27a.75.75,0,0,1-.37-.56l-.23-1.71A1.47,1.47,0,0,0,14,1.19a10.25,10.25,0,0,0-4,0A1.46,1.46,0,0,0,8.9,2.45c-.09.58-.18,1.29-.24,1.71a.75.75,0,0,1-.37.56L7.84,5a.69.69,0,0,1-.65.06L5.67,4.4a1.39,1.39,0,0,0-1.61.39,11.4,11.4,0,0,0-2,3.61A1.53,1.53,0,0,0,2.56,10l1.3,1.07a.76.76,0,0,1,.28.62q0,.27,0,.54a.77.77,0,0,1-.28.62l-1.3,1.06a1.54,1.54,0,0,0-.48,1.66,11.39,11.39,0,0,0,2,3.59,1.38,1.38,0,0,0,1.6.39l1.53-.64a.69.69,0,0,1,.65.06l.44.27a.75.75,0,0,1,.37.56l.23,1.71A1.47,1.47,0,0,0,10,22.81a10.26,10.26,0,0,0,4,0,1.46,1.46,0,0,0,1.12-1.25c.09-.58.18-1.29.24-1.71a.75.75,0,0,1,.37-.56l.44-.27a.69.69,0,0,1,.65-.06l1.53.65a1.39,1.39,0,0,0,1.61-.39,11.4,11.4,0,0,0,2-3.61A1.53,1.53,0,0,0,21.44,14ZM12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16Z"
        />
    </svg>
);

export const IconPinchToZoom = ({ className, size }) => (
    <svg
        className={className}
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 50 50"
        enableBackground="new 0 0 50 50"
        width={size}
        height={size}
        fill="white"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            stroke="#000"
            d="M16.528,1.955c-1.942,0.802-3.455,2.318-4.259,4.259   c-0.807,1.942-0.807,4.082,0,6.026c0.179,0.437,0.396,0.851,0.641,1.236c0.265,0.416,0.826,0.539,1.238,0.273   c0.418-0.266,0.541-0.821,0.274-1.239c-0.19-0.298-0.358-0.617-0.496-0.956c-0.64-1.546-0.593-3.209,0-4.645   c0.594-1.441,1.739-2.657,3.29-3.299c1.501-0.619,3.153-0.621,4.654,0.002c1.499,0.623,2.667,1.791,3.287,3.29   c0.143,0.345,0.253,0.698,0.329,1.049c0.106,0.484,0.564,0.79,1.07,0.686c0.482-0.104,0.789-0.582,0.686-1.066   c-0.1-0.456-0.243-0.909-0.425-1.356c-0.806-1.942-2.318-3.457-4.259-4.261C20.61,1.151,18.472,1.148,16.528,1.955 M3.451,6.844   C3.055,7.141,2.973,7.702,3.267,8.098c0.3,0.398,0.859,0.479,1.258,0.184L5.291,7.71L2.189,29.095l-0.574-0.769   c-0.296-0.398-0.857-0.479-1.254-0.182c-0.398,0.297-0.479,0.86-0.182,1.256l1.869,2.501c0.296,0.397,0.859,0.476,1.254,0.182   l2.501-1.866c0.396-0.297,0.478-0.858,0.182-1.256c-0.298-0.398-0.86-0.478-1.256-0.182l-0.766,0.572L7.065,7.967l0.574,0.768   c0.297,0.396,0.86,0.476,1.254,0.182c0.399-0.298,0.48-0.86,0.182-1.256L7.206,5.16C6.912,4.763,6.348,4.682,5.952,4.978   L3.451,6.844z M19.575,26.269c-1.75-1.025-3.79-1.31-5.744-0.796c-1.958,0.51-3.601,1.752-4.624,3.498   c-1.025,1.746-1.305,3.784-0.794,5.742c0.509,1.958,1.75,3.6,3.496,4.623c0.394,0.231,0.8,0.421,1.211,0.574   c0.456,0.184,0.982-0.069,1.153-0.527c0.174-0.461-0.061-0.978-0.527-1.152c-0.315-0.118-0.627-0.263-0.929-0.443   c-1.331-0.782-2.281-2.034-2.671-3.527c-0.389-1.495-0.174-3.05,0.608-4.382c0.782-1.334,2.034-2.282,3.529-2.672   c1.497-0.388,3.05-0.171,4.382,0.609c0.309,0.179,0.591,0.384,0.852,0.606c0.38,0.325,0.945,0.28,1.266-0.095   c0.323-0.375,0.278-0.943-0.098-1.267C20.345,26.769,19.976,26.502,19.575,26.269z M16.793,10.019l10.292,24.86   c-2.931-0.425-7.058-3.059-7.572-3.39c-0.539-0.347-1.113-0.598-1.685-0.765c-0.752-0.221-1.505-0.299-2.189-0.264   c-1.043,0.053-2.532,0.342-2.742,1.573c-0.251,1.483,1.67,3.266,2.734,3.959c2.087,1.364,4.756,4.415,7.148,6.216   c4.662,3.512,5.137,2.264,11.952,6.44L50,42.327c-0.844-3.432-0.078-8.556-1.031-12.421l-0.114-0.341l-5.225-12.732   c-0.568-1.374-2.163-2.034-3.535-1.464c-1.354,0.559-2.011,2.115-1.49,3.473l-0.004-0.01l-0.971-2.345   c-0.569-1.376-2.162-2.034-3.534-1.466c-1.364,0.565-2.024,2.14-1.479,3.502l-0.004-0.01l-0.98-2.368   c-0.599-1.444-2.271-2.136-3.712-1.538c-1.444,0.596-2.137,2.271-1.54,3.712L22.042,7.845c-0.597-1.444-2.269-2.136-3.713-1.537   C16.888,6.904,16.197,8.58,16.793,10.019z"
        />
    </svg>
);

export const IconThumbsUp = ({ className, size, ...props }) => (
    <svg
        version="1.1"
        style={{
            shapeRendering: "geometricPrecision",
            textRendering: "geometricPrecision",
            imageRendering: "optimizeQuality",
        }}
        viewBox="0 0 8467 8467"
        x="0px"
        y="0px"
        fillRule="evenodd"
        clipRule="evenodd"
        className={className}
        width={size}
        height={size}
        fill="currentColor"
        {...props}
    >
        <path d="M6747 3239l-1145 0c95,-381 351,-526 351,-1058 0,-971 -1106,-1799 -1385,-306 -83,402 -998,1857 -1405,1889 -137,13 -252,128 -252,265l0 2650c0,145 124,260 264,264 145,5 393,91 653,182 447,153 1005,348 1596,348 767,0 1636,12 1550,-1071 224,-214 311,-577 224,-872 200,-268 221,-574 116,-881 0,0 181,-1410 -567,-1410z" />
        <path d="M2646 4033l0 2646c0,144 -120,264 -265,264l-1190 0c-145,0 -265,-119 -265,-264l0 -2646c0,-145 120,-265 265,-265l1190 0c145,0 265,120 265,265l0 0z" />
    </svg>
);

export const ChargeIcon = ({ className, pathClassName }) => (
    <svg
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
        className={className}
    >
        <g transform="translate(0,-952.36218)">
            <path
                d="m 59,968.36219 -28,39.00001 18,0 -9,29 29,-39.00001 -18,0 z"
                className={pathClassName}
                style={{ paintOrder: "stroke" }}
                strokeWidth="10"
                strokeLinecap="round"
                marker="none"
                visibility="visible"
                display="inline"
                overflow="visible"
            />
        </g>
    </svg>
);

export const IconLightBulb = ({ className, size }) => (
    <svg
        className={className}
        width={size}
        height={size}
        fill="currentColor"
        viewBox="0 0 24 24"
    >
        <path d="M12.5 5.5c-.276 0-.5.224-.5.5s.224.5.5.5c1.083 0 1.964.881 1.964 1.964 0 .276.224.5.5.5s.5-.224.5-.5c0-1.634-1.33-2.964-2.964-2.964zM12.5 1c-4.136 0-7.5 3.364-7.5 7.5 0 1.486.44 2.922 1.274 4.165l.08.135c1.825 2.606 2.146 3.43 2.146 4.2v3c0 .552.448 1 1 1h2c0 .26.11.52.29.71.19.18.45.29.71.29.26 0 .52-.11.71-.29.18-.19.29-.45.29-.71h2c.552 0 1-.448 1-1v-3c0-.782.319-1.61 2.132-4.199.895-1.275 1.368-2.762 1.368-4.301 0-4.136-3.364-7.5-7.5-7.5zm2 18h-4v-1h4v1zm2.495-7.347c-1.466 2.093-2.143 3.289-2.385 4.347h-1.11v-2c0-.552-.448-1-1-1s-1 .448-1 1v2h-1.113c-.24-1.03-.898-2.2-2.306-4.22l-.077-.129c-.657-.934-1.004-2.024-1.004-3.151 0-3.033 2.467-5.5 5.5-5.5s5.5 2.467 5.5 5.5c0 1.126-.347 2.216-1.005 3.153z" />
    </svg>
);
